import {
  constructApplications,
  constructLayoutEngine,
  constructRoutes,
} from "single-spa-layout";
import { ResolvedRoutesConfig } from "single-spa-layout/dist/types/isomorphic/constructRoutes";
import { MFEConfigs, RegisterableApplication } from "../models/Models";
import { LayoutEngine } from "single-spa-layout/dist/types/browser/constructLayoutEngine";
import { registerMicrofrontend } from "./registerMicrofrontend";
import { addBeforeRoutingEventListener } from "./beforeRoutingEventListener";
import { replacePlaceholdersWithErrorAndLoadingUIParcels } from "./injectParcelsIntoPlaceholders";

export const buildLayoutEngine = async (
  mfeConfigs: MFEConfigs
): Promise<LayoutEngine> => {
  let routes: ResolvedRoutesConfig = constructRoutes(
    await replacePlaceholdersWithErrorAndLoadingUIParcels(mfeConfigs)
  );

  if (!routes) {
    throw new Error("Error, no routes constructed");
  }

  const applications: RegisterableApplication[] = constructApplications({
    routes,
    loadApp: ({ name }) => System.import(name),
  });

  if (!applications) {
    throw new Error("Error, no applications constructed");
  }

  applications.forEach((app: RegisterableApplication) =>
    registerMicrofrontend(app, mfeConfigs)
  );

  const layoutEngine: LayoutEngine = constructLayoutEngine({
    routes,
    applications,
  });

  if (!layoutEngine) {
    throw new Error("Error, no layoutEngine constructed");
  }

  addBeforeRoutingEventListener(
    mfeConfigs.baseconfig.global_configuration,
    console
  );

  return layoutEngine;
};
